module.exports = __webpack_public_path__ + "static/img/3.efdcd81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/eng/3.png
// module id = vpne
// module chunks = 0